import React, { useState, useEffect } from "react";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Container } from "reactstrap";
import { getStorageUser } from "../../helpers/api_helper";
import { PROFILES } from "../../components/VerticalLayout/SidebarContent";
import Dashboard from ".";
import EmptyDashboard from "./EmptyDashboard";

const DashboardSwitcher = () => {
  document.title = "Inicio | Sistema de Logística";

  const user = getStorageUser();

  if (![PROFILES.Reseller, PROFILES.SuperAdmin].includes(user.profile_id)) {
    return <Dashboard />;
  }

  return <EmptyDashboard />;
};
export default DashboardSwitcher;
